import { z } from "zod";

/**
 * Allowed user schema
 * Stores user metadata for display (not just IDs)
 */
export const AllowedUserSchema = z.object({
  id: z.string().uuid(), // Azure AD user ID
  displayName: z.string(),
  email: z.string().email() // User Principal Name (UPN)
});

export type AllowedUser = z.infer<typeof AllowedUserSchema>;
